globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.MobileNavigation = (function() {

  function MobileNavigation() {
    this.$body = $('body');
    this.$mobileHeader = $('.mobile-header');
    this.$mobilePageHeader = $('.mobile-page-header');

    this.$notificationToggler = this.$mobileHeader.find('#mobile-notifications-toggler');
    this.$notificationsOverlay = this.$mobileHeader.find('.mobile-notifications-overlay');

    this.$mobileHeaderSecondaryNavigationToggler = this.$mobileHeader.find('#mobile-header-secondary-navigation-toggler');
    this.$mobileHeaderSecondaryNavigationOverlay = this.$mobileHeader.find('.mobile-header-secondary-navigation-overlay');

    this.$mobilePageSecondaryNavigationToggler = this.$mobilePageHeader.find('#mobile-page-secondary-navigation-toggler');
    this.$mobilePageSecondaryNavigationOverlay = this.$mobilePageHeader.find('.mobile-page-secondary-navigation-overlay');

    this.init();
  }

  MobileNavigation.prototype = {
    init: function(){
      var _this = this;

      _this.$notificationToggler.on('click', function(){
        _this._mobileHeaderSecondaryNavigationOverlayDisplayState(false);
        _this._notificationsOverlayDisplayState(!_this._notificationsOverlayIsOpen());
      });

      _this.$mobileHeaderSecondaryNavigationToggler.on('click', function(){
        _this._notificationsOverlayDisplayState(false);
        _this._mobileHeaderSecondaryNavigationOverlayDisplayState(!_this._mobileHeaderSecondaryNavigationOverlayIsOpen());
      });

      _this.$mobilePageSecondaryNavigationToggler.on('click', function(){
        _this._mobilePageSecondaryNavigationOverlayDisplayState(!_this._mobilePageSecondaryNavigationOverlayIsOpen());
      });
    },
    _notificationsOverlayIsOpen: function(){
      return this.$notificationsOverlay.hasClass('in')
    },
    _notificationsOverlayDisplayState: function(state){
      var _this = this;

      if(state) {
        _this.$body.addClass('no-scroll');
        _this.$notificationsOverlay.addClass('in').show();
      } else {
        _this.$notificationsOverlay.removeClass('in').addClass('out');
        setTimeout(function(){
          _this.$notificationsOverlay.removeClass('out').hide();
          _this.$body.removeClass('no-scroll');
        }, 200)
      }
    },
    _mobileHeaderSecondaryNavigationOverlayIsOpen: function(){
      return this.$mobileHeaderSecondaryNavigationOverlay.hasClass('in')
    },
    _mobileHeaderSecondaryNavigationOverlayDisplayState: function(state){
      var _this = this;

      if(state) {
        _this.$body.addClass('no-scroll');
        _this.$mobileHeaderSecondaryNavigationOverlay.addClass('in').show();
      } else {
        _this.$mobileHeaderSecondaryNavigationOverlay.removeClass('in').addClass('out');
        setTimeout(function(){
          _this.$mobileHeaderSecondaryNavigationOverlay.removeClass('out').hide();
          _this.$body.removeClass('no-scroll');
        }, 200)
      }
    },
    _mobilePageSecondaryNavigationOverlayIsOpen: function(){
      return this.$mobilePageSecondaryNavigationOverlay.hasClass('in')
    },
    _mobilePageSecondaryNavigationOverlayDisplayState: function(state){
      var _this = this;

      if(state) {
        _this.$body.addClass('no-scroll');
        _this.$mobilePageSecondaryNavigationOverlay.addClass('in').show();
      } else {
        _this.$mobilePageSecondaryNavigationOverlay.removeClass('in').addClass('out');
        setTimeout(function(){
          _this.$mobilePageSecondaryNavigationOverlay.removeClass('out').hide();
          _this.$body.removeClass('no-scroll');
        }, 200)
      }
    },
  }

  return MobileNavigation;

})();
